import { useMemo } from 'react';
import { Col, Row, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { Match, MatchStatus, WinningTeam } from '../../models/interfaces/Match';
import { User } from '../../models/interfaces/User';
import { generateScoreSheetPDF } from './GenerateMatchPDF';
import { SportProvider } from '../../models/interfaces/SportProvider';

interface Props {
    match: Match;
    winningTeam: WinningTeam;
    sportProvider: SportProvider;
    showScoreSheet: boolean;
    user?: User;
}

const MatchChipView = ({ match, winningTeam, sportProvider, showScoreSheet, user }: Props) => {
    const dateString = `${match.date.toLocaleDateString()} ${match.date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
    })}`;

    const inProgressString = `${match.status === MatchStatus.inProgress ? 'In Progress' : ''}`;

    const competitionAttributesString = sportProvider.displayTextForTeamOrCompetitionAttributes(
        match.competition.attributes
    );

    const lightCapTeamLink = useMemo(() => {
        return `/competitions/${match.competition.id}/entries/${match.lightCapTeam.id}`;
    }, [match.lightCapTeam, match.competition.id]);

    const darkCapTeamLink = useMemo(() => {
        return `/competitions/${match.competition.id}/entries/${match.darkCapTeam.id}`;
    }, [match.darkCapTeam, match.competition.id]);

    return (
        <Card className="mb-4 text-center">
            <Card.Header>
                {/* as match.competition can be null this checks that it is true first */}
                {!!match.competition && (
                    <>
                        <strong>
                            <Link
                                to={`/competitions/${!!match.competition && match.competition.id}`}
                            >
                                {match.competition.attributes.name}
                            </Link>
                        </strong>
                        <div>{competitionAttributesString}</div>
                    </>
                )}
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col>{dateString}</Col>
                </Row>
                {inProgressString && (
                    <Row>
                        <Col>
                            <i>{inProgressString}</i>
                        </Col>
                    </Row>
                )}
                <Row>
                    <Col>
                        <Link to={lightCapTeamLink}>
                            <span className={winningTeam.light ? 'font-weight-bold' : ''}>
                                {`${match.lightCapTeam.name}`}
                            </span>
                        </Link>
                        <span> vs </span>
                        <Link to={darkCapTeamLink}>
                            <span
                                className={winningTeam.dark ? 'font-weight-bold' : ''}
                            >{`${match.darkCapTeam.name}`}</span>
                        </Link>
                    </Col>
                </Row>
                {match.status === MatchStatus.completed && showScoreSheet && (
                    <Row className="mt-3">
                        <Col>
                            <Button
                                block
                                onClick={() => {
                                    generateScoreSheetPDF(sportProvider, match, user).catch(() => {
                                        // CBTODO
                                        // fire error
                                    });
                                }}
                            >
                                Download Score Sheet
                            </Button>
                        </Col>
                    </Row>
                )}
            </Card.Body>
        </Card>
    );
};

export default MatchChipView;
